import { useEffect, useRef, useState } from 'react';

import { formatDate } from 'utils/helper';

const MenuItem = ({ item, currentConversation, handleClickConversation }) => {
  const [time, setTime] = useState('');

  const timeIntervalRef = useRef(null);

  // INTERVAL FORMAT TIME
  const handleFormatTime = () => {
    setTime(formatDate(item.last_message_time));
  };

  useEffect(() => {
    const tick = () => {
      handleFormatTime();
    };
    handleFormatTime();
    timeIntervalRef.current = setInterval(tick, 30000);
    return () => clearInterval(timeIntervalRef.current);
  }, [item.last_message_time]);

  return (
    <div
      key={item.id}
      className={`cursor-pointer flex gap-8 items-start justify-between px-8 py-2.5 hover:bg-primary-727 ${item.is_unread ? 'font-bold text-black' : 'text-black/85'} ${currentConversation === item.conversation_id ? 'bg-primary-727' : ''}`}
      onClick={() => handleClickConversation(item)}
    >
      <div className="grid grid-cols-1 gap-2 items-center">
        <p className="line-clamp-1">
          {Number(item.participant_id) !== -1 && <span>{item.participant_id}&nbsp;-&nbsp;</span>}
          <span>{item.participant_name || '-'}</span>
        </p>
        <div
          className="line-clamp-1 text-sm break-all"
          dangerouslySetInnerHTML={{ __html: item.last_message_content ? item.last_message_content?.replace(/\n/g, '<br />') : '&nbsp;' }}
        />
      </div>
      <p className="text-sm first-letter:uppercase whitespace-nowrap">{item.last_message_time ? time : ''}</p>
    </div>
  );
};

export default MenuItem;
